import { useLocation } from 'react-router-dom';

function useHomeLinkClick(onNavigate) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (event) => {
    if (onNavigate) onNavigate();

    if (isHomePage) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
}

export default useHomeLinkClick;
